export default __webpack_public_path__ + "static/media/DSC_0555.55369b1b.webp";